import { Pipe, PipeTransform } from '@angular/core';
import { NumericOperationManager } from '../utils/numeric-operation-manager';

@Pipe({
    name: 'percentage'
})
export class PercentagePipe implements PipeTransform {
  transform(value: string, percentage: number): string {
    let a;
    if (value) {
      a = value.toString().trim().replace(',', '.');
    }else {
      a = '0';
    }
    if (!percentage) {
      percentage = 0;
    }
    let resultNum: number = +a / 100 * percentage;
    let result: number= Math.round(resultNum *100)/100;
    let formatString = NumericOperationManager.getSum([ String(result), '0']);
    return formatString;
  }
}
